import React from 'react'
import { useParams } from 'react-router-dom'
import MilestoneForm from './MilestoneForm'

const MilestoneEdit = () => {
  const { id } = useParams()
  
  return <MilestoneForm mode="edit" milestoneId={id} />
}

export default MilestoneEdit

